export const BOOK_APPOINTMENT_URL_HVAC =
  'https://app.orcatec.com/public-appointments?nc3tXxmbld';

export const BOOK_APPOINTMENT_URL_CONSTRUCTION =
  'https://app.orcatec.com/public-appointments?7GUNiBdr2C';

const NON_HVAC_SERVICE_PATHS = [
  // '/services/electrical',
  '/services/plumbing',
  '/services/remodeling',
  '/services/construction',
  // '/services/brokerage',
] as const;

export function getBookAppointmentUrl(pathname: string): string {
  const isNonHvac = NON_HVAC_SERVICE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
  return isNonHvac
    ? BOOK_APPOINTMENT_URL_CONSTRUCTION
    : BOOK_APPOINTMENT_URL_HVAC;
}
